const subCollectionFetchCache = {}

class SubCollection extends HTMLElement {
  constructor() {
    super()
    const page = new URLSearchParams(window.location.search).get('page')

    // "Self-destruct" if we're past the first page of results - these are only shown on page 1.
    if (page && page > 1) {
      this.classList.add('hidden')
      // Also hide the subcollection nav, since no subcollections will be shown.
      document
        .querySelectorAll(
          '#main-collection-filters .collection-titles__wrapper .collection-filters__title'
        )
        .forEach((el) => el.classList.add('hidden'))
      return
    }

    this.handle = this.dataset.collectionHandle
    this.initial = true

    if (this.handle != undefined) {
      this.queryParams = window.location.search.substring(1)
      this.collectionUrl = `${window.location.origin}/collections/${this.handle}?${this.queryParams}&view=subcollection`
      this.loadMoreUrl = null
      this.fetchInitialSubCollection(this.collectionUrl, this.handle)
    }
  }

  async fetchInitialSubCollection(collectionUrl, handle) {
    const collectionHTML =
      subCollectionFetchCache[collectionUrl] ||
      (await fetch(collectionUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText
          const collectionHTML = new DOMParser().parseFromString(
            html,
            'text/html'
          )

          subCollectionFetchCache[collectionUrl] = collectionHTML

          return collectionHTML
        }))

    if (collectionHTML) {
      const fetchSubCollectionContainer =
        collectionHTML?.querySelector('.js-collection')
      const collectionWrapper = document.querySelector(
        `.js-collection[data-collection-id="#AjaxinateContainer--${handle}"]`
      )
      const queryParams = window.location.search.substring(1)

      if (!collectionWrapper) {
        return null
      }

      const filterLinks = document.querySelectorAll(
        `#main-collection-filters .collection-filters__title:has([href='#navigation--${this.handle}'])`
      )
      // Hide entire custom element if no results were fetched; also hide sub nav option
      if (
        fetchSubCollectionContainer.getAttribute('data-products-count') == 0
      ) {
        this.classList.add('hidden')
        filterLinks.forEach((link) => link.classList.add('hidden'))
      } else {
        this.classList.remove('hidden')
        this.removeAttribute('style')
        filterLinks.forEach((link) => link.classList.remove('hidden'))
      }

      collectionWrapper.innerHTML = fetchSubCollectionContainer.innerHTML
      if (
        collectionWrapper.contains(
          collectionWrapper.querySelector('.js-load-more-url')
        )
      ) {
        collectionWrapper.setAttribute(
          'data-initial-height',
          collectionWrapper.offsetHeight
        )
        this.loadMoreUrl = collectionWrapper.querySelector('.js-load-more-url')
        this.loadMoreUrl.setAttribute(
          'href',
          `${window.location.origin}/collections/${handle}?${queryParams}&view=subcollection-load-more&page=1`
        )
      }
      Collection.setSubmenu(true)
      Collection.addImagesObserver()
    }
  }
}
customElements.define('sub-collection', SubCollection)
